exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/BHAJ/Desktop/dribbler/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/BHAJ/Desktop/dribbler/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/Users/BHAJ/Desktop/dribbler/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles